import { useHistory } from "react-router-dom";

import { useAppState } from "@/components/AppStateProvider";
import Box from "@/components/Box";
import OrganisationBadge from "@/components/organisations/shared/ui/OrganisationBadge";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { AFFILIATE } from "@/core/constants";
import { theme } from "@/core/theme";
import { CMP_SHOP_URL, DASHBOARD_HOME_URL, SETTINGS_URL } from "@/core/urls";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";

import Center from "./Center";
import Jumbotron from "./Jumbotron";
import SegmentedControl from "./SegmentedControl";
import Stack from "./Stack";

function getInitials(string) {
  // Source: https://stackoverflow.com/a/33076323
  var names = string.split(" "),
    initials = names[0].substring(0, 1).toUpperCase();

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
}

export default function Header({ bg, mt, isPartnerPage, title }) {
  const organisationContext = useOrganisationContext();

  const { userInfo } = useAppState();

  if (!userInfo || !userInfo?.user) return <Jumbotron title="Dashboard" mt={mt} />;

  if (
    !userInfo.user.practitionerProfile?.id ||
    userInfo.user.practitionerProfile?.tier === AFFILIATE
  ) {
    return <Jumbotron title="Dashboard" mt={mt} />;
  }

  const pb = [40, 40, 80];

  const organisation = organisationContext?.organisation;

  const cmpView = isPartnerPage && organisation;

  const headerTitle =
    title ?? (cmpView && userInfo.user.firstName ? `Welcome ${userInfo.user.firstName}` : null);

  return (
    <Stack
      bg={bg}
      px={[20, 20, 40, 40]}
      mt={mt}
      data-component-name="DashboardSwitcher"
      gap={0}
      pt={theme.spacing.pageHeader.pt}
    >
      <Stack
        justifyContent={!cmpView ? "center" : null}
        maxWidth={1538}
        width="100%"
        mx="auto"
        gap={[70, 70, 0]}
        position="relative"
      >
        {cmpView && (
          <OrganisationBadge
            fullName={organisation.name}
            initials={getInitials(organisation.name)}
            ml="auto"
            position="absolute"
            top="20px"
            right="0"
            display={["none", "flex"]}
          />
        )}
      </Stack>
      {headerTitle && (
        <Box
          mx="auto"
          maxWidth={1528}
          width="100%"
          fontFamily="gilroyBold"
          fontSize={[32, 32, 32]}
          lineHeight="50px"
          mt="auto"
          pb={28}
          pt={60}
        >
          {headerTitle}
        </Box>
      )}
    </Stack>
  );
}

Header.defaultProps = {
  bg: "purple"
};
